<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item label="发送时间：">
      <el-date-picker v-model="filters.dateTime" type="daterange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" value-format="yyyy-MM-dd" unlink-panels>
      </el-date-picker>
    </el-form-item>
    <el-form-item>
      <el-input class="filter-input" prefix-icon="el-icon-search" v-model="filters.nameOrMobile"
        placeholder="接收人姓名/手机"></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getOneYearArr } from "@/utils/timeFormat";
export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      filters: {
        dateTime: [],
      },
    };
  },

  created() {
    this.filters = {
        dateTime: getOneYearArr(),
      };
    this.$nextTick(() => {
      this.initData();
    })

  },

  methods: {
    initData() {
      let params = Object.assign({}, this.filters);
      delete params.dateTime;
      if (this.filters.dateTime) {
        params["startDate"] = this.filters.dateTime[0];
        params["endDate"] = this.filters.dateTime[1];
      }
      this.$emit("search", { ...params, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = {
        dateTime: getOneYearArr(),
      };
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>

<style scoped>
.filter-input {
  width: 220px;
}
</style>
